export default "__VITE_ASSET__BLlsAlFA__"